__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/4722cdfc4533d9fa63abe1da5ac7513cbb7d2371/_next/";